import React from 'react';
import Grid from '@components/basics/grid';
import Typography from '@components/basics/typography';
import { Translate } from 'react-localize-redux';
import styled, { useTheme } from 'styled-components';
import Flex from '@components/layout/flex';
import { Ownership } from '@services/ownership/types/ownership';

interface BoxHeaderProps {
  assetType: string;
  tabActive?: 'recordings' | 'publishing';
  recordingOwnerships: Ownership[];
  publishingOwnerships: Ownership[];
  userId: string;
  canEditAllOwnerships: boolean;
  tabClick: (tabName: 'recordings' | 'publishing') => void;
}

export const BoxHeader: React.FC<BoxHeaderProps> = ({
  assetType,
  tabActive,
  recordingOwnerships,
  publishingOwnerships,
  userId,
  canEditAllOwnerships,
  tabClick,
}) => {
  const theme = useTheme();

  return (
    <>
      <Grid className="mb-30" gap={10}>
        <Typography type="subheader" customFont="semi-bold">
          <Translate id="OWNERSHIP.TITLE" />
        </Typography>
        <Typography color={theme.colors.tertiary}>
          <Translate id="OWNERSHIP.TEXT" />
        </Typography>
      </Grid>
      <Flex gap={30} className="mb-30">
        {(recordingOwnerships.some((o) => o.ownerId === userId) ||
          canEditAllOwnerships) && (
          <TabType
            className={tabActive === 'recordings' ? 'active' : ''}
            type="big-title"
            customFont="semi-bold"
            onClick={() => tabClick('recordings')}
          >
            <Translate
              id="OWNERSHIP.TABS.RECORDINGS"
              data={{
                amount: recordingOwnerships.length,
              }}
            />
          </TabType>
        )}
        {assetType === 'track' &&
          (publishingOwnerships.some((o) => o.ownerId === userId) ||
            canEditAllOwnerships) && (
            <TabType
              className={tabActive === 'publishing' ? 'active' : ''}
              type="big-title"
              customFont="semi-bold"
              onClick={() => tabClick('publishing')}
            >
              <Translate
                id="OWNERSHIP.TABS.PUBLISHING"
                data={{
                  amount: publishingOwnerships.length,
                }}
              />
            </TabType>
          )}
      </Flex>
    </>
  );
};

const TabType = styled(Typography)`
  cursor: pointer;
  opacity: 0.5;
  transition: opacity
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  &.active,
  &:hover {
    opacity: 1;
  }
`;
